import { schema  as schemaPID } from './Functions/PID'
import { schema  as schemaControlledPID } from './Functions/ControlledPID'
import { schema  as schemaControlled2Point } from './Functions/Controlled2Point'
import { schema  as schemaOptimizer } from './Plants/Optimizations/AHU_Optimizer'
import { schema  as schemaScheduler } from './Functions/Scheduler'
import { schema  as schemaControlledScheduler } from './Functions/ControlledScheduler/types'
import { schema  as schemaCalendar } from './Functions/Calendar'
import { schema  as schemaControlledCalendar } from './Functions/ControlledCalendar/types'

export function isParameterApp(modelId: string): boolean {
    return modelId.startsWith('AutomationApps.FunctionGroups') ||
    modelId.startsWith('AutomationApps.Functions.SetPoints') ||
    modelId.startsWith('AutomationApps.Logics') ||
    modelId === schemaPID ||
    modelId === schemaControlledPID ||
    modelId === schemaControlled2Point ||
    modelId === schemaOptimizer ||
    modelId === schemaScheduler ||
    modelId === schemaCalendar ||
    modelId === schemaControlledScheduler || 
    modelId === schemaControlledCalendar
}